import { useMemo } from "react";

import { TransactionFragment } from "@/__generated__/graphql";
import { DataView } from "@/components/organisms/DataView";
import { useConnectionSetup } from "@/hooks/useConnectionSetup";
import { Objects } from "@/objects";
import { State } from "@/state";

import { usePrepareDataViewThread } from "../shared/dataViewThread.tools";
import {
  transactionToThreadContext,
  TransactionsViewThreadActions,
} from "./TransactionsViewThreadActions";

export function TransactionsView() {
  const dataViewMode = State(
    (store) => store.dataViewModes[store.activeAppView] ?? "table",
  );

  const {
    columns,
    rows,
    loading,
    totalCount,
    loadNext,
    deleteNodeButtonProps,
    networkStatus,
  } = useConnectionSetup({ appView: "transactions" });

  const transactionRows = rows as TransactionFragment[];
  const prepareThread = usePrepareDataViewThread(
    transactionRows,
    transactionToThreadContext,
  );

  const onCheckedRowsExtraActions = useMemo(
    () => (props: { checkedRowIds: string[]; clearSelection: () => void }) => (
      <TransactionsViewThreadActions
        {...props}
        onPrepareThread={prepareThread}
      />
    ),
    [prepareThread],
  );

  return (
    <DataView
      totalCount={totalCount}
      columns={columns}
      rows={transactionRows}
      loadNext={loadNext}
      isLoading={loading}
      networkStatus={networkStatus}
      onCheckedRowsExtraActions={onCheckedRowsExtraActions}
      onCheckedRowsButtonsProps={[deleteNodeButtonProps]}
      viewMode={dataViewMode}
      placeholderRow={Objects.TransactionObject.placeholder}
      // A payment is its amount and a line about it: a short card.
      cardSize="sm"
      onAddNew={() =>
        State.getState().pushToCommandStack({
          commandDefinitionId: "create-TransactionObject",
        })
      }
    />
  );
}
